import { Fragment, useCallback, useState } from 'react';

import coin from '~/assets/icons/coin.svg';
import percent from '~/assets/icons/percent.svg';
import plusRound from '~/assets/icons/plus_round.svg';
import { CurrencyIcon } from '~/components/collections';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { rage, useObservable } from '~/rage';
import { BankOperationType, Currency, WalletType } from '~/shared';
import {
	setDepositValue,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { MoneyButton } from '../MoneyButton';
import { MoneyInput } from '../MoneyInput';
import { SectionHeading } from '../SectionHeading';
import {
	StyledButtonContent,
	StyledContainer,
	StyledMoneyButtonsContainer,
	StyledMoneyButtonsFirstRow,
	StyledMoneyButtonsSecondRow,
	StyledSectionContainer,
	StyledSummaryContainer,
} from './DepositMoney.styled';

const DepositMoney: React.FC = () => {
	const dispatch = useLayoutDispatch();
	const value = useLayoutSelector((state) => state.bank.depositValue);
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const fee = useObservable(
		rage.bank.getTransferFee(BankOperationType.DEPOSIT),
	);

	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	const deposit = useCallback(async () => {
		setIsLoading(true);
		try {
			await rage.bank.exchange(WalletType.Cash, WalletType.Bank, value);
		} catch (e) {
			// @TODO: какой-то вывод ошибки
		} finally {
			setIsLoading(false);
		}
	}, [value]);

	return (
		<StyledContainer>
			<StyledSectionContainer>
				<SectionHeading icon={coin} text={'Введите сумму пополнения'} />
				<MoneyInput
					value={value}
					changeHandler={(value: number) => dispatch(setDepositValue(value))}
					currency={Currency.Ruble}
				/>
				<StyledMoneyButtonsContainer>
					<StyledMoneyButtonsFirstRow>
						<MoneyButton
							text={'1 000'}
							onClick={() => dispatch(setDepositValue(value + 1000))}
						/>
						<MoneyButton
							text={'10 000'}
							onClick={() => dispatch(setDepositValue(value + 10000))}
						/>
						<MoneyButton
							text={'100 000'}
							onClick={() => dispatch(setDepositValue(value + 100000))}
						/>
					</StyledMoneyButtonsFirstRow>
					<StyledMoneyButtonsSecondRow>
						<MoneyButton
							text={'1 000 000'}
							onClick={() => dispatch(setDepositValue(value + 1000000))}
						/>
						<MoneyButton
							text={'10 000 000'}
							onClick={() => dispatch(setDepositValue(value + 10000000))}
						/>
					</StyledMoneyButtonsSecondRow>
					<MoneyButton
						text={'100 000 000'}
						onClick={() => dispatch(setDepositValue(value + 100000000))}
					/>
				</StyledMoneyButtonsContainer>
			</StyledSectionContainer>
			<StyledSummaryContainer>
				<Text>Вам зачислится</Text>
				<Text>{Math.floor(value - value * fee).toLocaleString('ru-RU')}</Text>
				<CurrencyIcon icon={rubleIcon} size="sm" />
				{fee ? (
					<Fragment>
						<Text>Комиссия банка</Text>
						<Text style={{ justifySelf: 'end' }}>
							{(fee * 100).toLocaleString('ru-RU')}
						</Text>
						<img src={percent} width={14} height={14} />
					</Fragment>
				) : null}
			</StyledSummaryContainer>
			<Button
				color={ButtonColors.Select2}
				height={ButtonHeight.Height60}
				disabled={isLoading || value === 0}
				onClick={deposit}
				style={{ position: 'absolute', bottom: 0, width: '100%', fontSize: 18 }}
			>
				<StyledButtonContent>
					{value !== 0 && <img src={plusRound} width={20} height={20} />}
					<Text>{value ? 'Пополнить баланс' : 'Введите сумму пополнения'}</Text>
				</StyledButtonContent>
			</Button>
		</StyledContainer>
	);
};

export { DepositMoney };
